// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@conklin/Overrides/Widgets/Brand/BrandGallery";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { xScreen } from "@conklin/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

listStyles.carouselImage = {
    css: css`
        ${({ isCarouselView }: any) =>
            isCarouselView &&
            `
        &,
        &&& picture > img {
            width: 204px !important;
            height: 102px;
            object-fit: contain;
        }
    `}
        & {
            ${xScreen("lte", "md")} {
                width: 156px !important;
                height: auto;
            }
        }
    `,
};

listStyles.titleText = {
    variant: "h2",
};

listStyles.slide = {
    css: css`
        display: flex;
        justify-content: center;
        height: 100%;
    `,
};

listStyles.imageContainer = {
    css: css`
        justify-content: flex-start;
        gap: 32px 22px;
    `,
};

listStyles.imageItem = {
    css: css`
        &&&& {
            padding: 0;
            ${({ width }: any) =>
                width &&
                `
                max-width: ${width}px;
            `}
        }
    `,
};

listStyles.link = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

listStyles.brandItemWrapper = {
    css: css`
        box-sizing: border-box;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        ${({ width }: any) =>
            width &&
            `
            width: ${width}px;
            height: ${width}px;
            + ${TypographyStyle}{
                max-width: ${width}px;
            }
        `}
        ${xScreen("lte", "md")} {
            width: 232px;
            height: 232px;
        }
        ${xScreen("lte", "sm")} {
            width: 156px;
            height: 156px;
        }
    `,
};

listStyles.image = {
    css: css`
        max-width: 204px;
        max-height: 100%;
        height: auto;
        ${xScreen("lte", "sm")} {
            padding: 1px;
        }
    `,
};

listStyles.brandName = {
    size: 16,
    weight: fontConfig.weight.bold,
    lineHeight: "19px",
    color: "text.link",
    css: css`
        text-align: center;
    `,
};
